import request from '@Sys~/api/request'
import { apiUrl, type } from './env'
import store from '@Sys~/store'

const gateUrl = apiUrl.gateUrl

function ajax_fn(url, data, method, header) {
    header.header_username = encodeURI(store.getters.realName); // realName
    return request({
        headers: header,
        baseURL: gateUrl,
        url: url,
        method: method,
        data: data,
        withCredentials: false
    })
}

//数据源管理模块
//获取数据
export function queryBy_searchForm(data) {
    return ajax_fn("/datasource/list", data, "post", {})
}
//新增
export function create_datasForm(data) {
    return ajax_fn("/datasource/create", data, "post", {})
}
//修改
export function update_datasForm(data) {
    return ajax_fn("/datasource/update", data, "post", {})
}
//查看某条数据
export function queryBy_datas(data) {
    return ajax_fn("/datasource/queryById?id="+data.id, {}, "get", {})
}
//删除某条数据
export function deleteBy_datas(data) {
    return ajax_fn("/datasource/remove?ids="+data.id, {}, "get", {})
}
//测试连接
export function testConnect_datas(data) {
    return ajax_fn("/datasource/testConnected", data, "post", {})
}
//测试同步
export function syncConnect_datas(data) {
    return ajax_fn("/datasource/sync?id="+data.id, {}, "get", {})
}


// 下载
export function download_export(data,url) {
    var form = document.createElement("form");
    form.style.display = "none";
    form.action = gateUrl + url;
    form.method = "post";
    document.body.appendChild(form);

    for (var key in data) {
        if (key == "params") {
            for (var keys in data.params) {
                var input = document.createElement("input");
                input.type = "hidden";
                input.name = "params[" + keys + "]";
                input.value = data.params[keys];
                form.appendChild(input);
            }
        } else {
            var input = document.createElement("input");
            input.type = "hidden";
            input.name = key;
            input.value = data[key];
            form.appendChild(input);
        }
    }
    console.log(form)
    form.submit();
    form.remove();
}
